/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * Selected wording for the `athlete` term.
 */
export type AthleteTerm = (typeof AthleteTerm)[keyof typeof AthleteTerm];

export const AthleteTerm = {
  athlete: "athlete",
  player: "player",
} as const;
